export default function PHP_header_remove() {
  return (
    <div>
      <h1>PHP_header_remove</h1>
    </div>
  );
}
